<template>
  <div>
    <div class="w-full space-y-6">

      <!-- Heading -->
      <h2 class="font-serif text-3xl font-bold text-center text-gray-900 leading-tight">
        Verify OTP
        <span class="block mt-2 font-sans text-sm font-normal text-gray-500">sent to {{ maskedContact }}</span>
      </h2>

      <!-- OTP Form -->
      <form @submit.prevent="submit" class="space-y-4">
        <input
          type="text"
          placeholder="Enter OTP"
          v-model="otp"
          maxlength="6"
          required
          inputmode="numeric"
          autocomplete="one-time-code"
          class="form-input text-center text-lg tracking-[0.5em]"
        />
        <button
          type="submit"
          class="btn-cream w-full py-3"
        >
          Verify OTP
        </button>
      </form>

      <!-- Resend OTP -->
      <button
        @click="resendOtp"
        class="text-brand-red font-medium hover:underline text-sm w-full text-center"
      >
        Resend OTP
      </button>

    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const emit = defineEmits(["success","error","switch"]);

const otp = ref("");

// Get contact dynamically from sessionStorage
const contact = sessionStorage.getItem("signupData")
  ? JSON.parse(sessionStorage.getItem("signupData")).contact
  : sessionStorage.getItem("resetContact") || "";

// Masked contact for display: 1234****78
const maskedContact = ref(
  contact ? contact.replace(/(\d{4})\d{4}(\d{2})/, "$1****$2") : ""
);

const baseUrl = process.env.VUE_APP_API_BASE_URL || "https://sanskritirdapoon.in/api";

// Submit OTP
const submit = async () => {
  if (!contact) return emit("error", "No contact found for verification.");

  // Decide which endpoint to hit based on context
  const isSignupFlow = !!sessionStorage.getItem("signupData");
  const endpoint = isSignupFlow ? "/verify-otp" : "/verify-reset-otp";

  try {
    const res = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ contact, otp: otp.value }),
    });

    const data = await res.json();

    if (!res.ok) return emit("error", data.error || "OTP verification failed!");

    // Different success messages based on flow
    if (isSignupFlow) {
      emit("success", "Account created successfully. Please Login");
    } else {
      emit("success", "OTP verified!");
    }

    // Decide next step
    if (isSignupFlow) {
      emit("switch","login"); // After signup OTP
      sessionStorage.removeItem("signupData"); // Clear temp data
    } else {
      emit("switch","reset"); // After forgot password OTP
    }

  } catch {
    emit("error","Connection error");
  }
};

// Resend OTP
const resendOtp = async () => {
  if (!contact) return emit("error","No contact found.");

  const isSignupFlow = !!sessionStorage.getItem("signupData");

  try {
    // For signup, trigger /signup again with stored data; for reset, call /forgot-password again
    let res;
    if (isSignupFlow) {
      const signupData = JSON.parse(sessionStorage.getItem("signupData"));
      res = await fetch(`${baseUrl}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupData),
      });
    } else {
      res = await fetch(`${baseUrl}/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contact }),
      });
    }

    const data = await res.json();
    if (!res.ok) return emit("error", data.error || "Failed to resend OTP!");

    emit("success", "OTP resent!");
  } catch {
    emit("error","Connection error");
  }
};
</script>
